<template>
    <div class="container">
        <!-- <Breadcrumb class="bread_block" /> -->
        <CommonBreadcrumb class="bread_block" />
        <div class="row">
            <div class="col-lg-3 col-md-4">
                <CustomerServicePolicyMenu />
            </div>
            <div class="col-lg-9 col-md-8">
                <CustomerServiceRingResizingIndia v-if="$country.is_india" />
                <CustomerServiceRingResizingUs v-else />

                <CustomerServicePolicyContactIndia v-if="$country.is_india" />
                <CustomerServicePolicyContact  v-else />
            </div>
        </div>
    </div>
</template>


<script setup>
const { $country } = useNuxtApp()
useFetchMeta( useNuxtApp(), useRuntimeConfig() );
</script>

<style scoped>
.main_title {
    margin: 4% 0;
}
.main_title h2 {
    font-size: 40px;
    text-align: center;
}
h1{
    font-size: 32px;
    text-transform: capitalize;
}
p {
    margin-bottom: 0;
    color: #6a6161;
    font-size: 16px;
    font-weight: 500;
}
ul {
    margin-left: 25px;
    padding-left: 0;
}
ul li{
    color: #6a6161;
    font-size: 16px;
    font-weight: 500; 
}
h3, h2 {
    font-size: 21px;
    font-weight: 500;
    margin: 30px 0 20px;
}
h4{
    margin-bottom: 6px;
    color: #6a6161;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.5;
}
a{
    color: #668b84;
    text-decoration: underline;
}

@media(min-width:1024px) and (max-width: 1550px){
    .container{
        max-width: 992px;
    }
}
@media(max-width: 767px){
    .main_title h2{
        font-size: 32px;
    }
    .main_title {
        margin: 13% 0 10%;
    }
    h1{
        font-size: 24px;
    }
    h3, h2{
        font-size: 20px;
    }
}
</style>
